import { useEffect, useState } from "react";
import { History, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, dt, errMsg } from "@/lib/api";
import { ErrorBox, Field, Modal } from "@/components/common";
import { SelectionInfo } from "@/components/Selection";

const ACTION = { sale_created: "إنشاء البيع", payment_recorded: "تسجيل دفعة", payment_cancelled: "إلغاء دفعة", price_changed: "تعديل السعر/الخصم",
  sale_info_updated: "تعديل الفئة/الملاحظات", sale_cancelled: "إلغاء البيع", customer_updated: "تعديل بيانات الزبون", permit_issued: "إصدار تصريح خروج",
  permit_cancelled: "إلغاء تصريح", permit_delivered: "تسليم الكبش", exit_confirmed: "خروج من البوابة", selection_created: "تسجيل الاختيار في الحضيرة",
  selection_photo_added: "إضافة صورة", permit_verified: "تحقق من التصريح" };
const fmt = (o) => (o ? Object.entries(o).map(([k, v]) => `${k}: ${v ?? "—"}`).join(" • ") : "");

export function SaleHistory({ saleId, stamp }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/sales/${saleId}/history`).then((r) => setRows(r.data)).catch((e) => setErr(errMsg(e))); }, [saleId, stamp]);
  return (
    <section className="k-card p-5" data-testid="sale-history">
      <div className="font-display font-bold text-lg mb-3 flex items-center gap-2"><History className="w-5 h-5" /> سجل المعاملة والتغييرات</div>
      <ErrorBox text={err} />
      {!rows ? <Loader2 className="w-5 h-5 animate-spin" /> : !rows.length ? <div className="text-sm text-slate-500">لا توجد أحداث</div> : (
        <ol className="space-y-2 border-r-2 border-[#1A4D2E]/20 pr-4">
          {rows.map((r) => (
            <li key={r.id} className="text-sm" data-testid="history-item">
              <div className="flex flex-wrap gap-2 items-baseline"><b>{ACTION[r.action] || r.action}</b><span className="text-xs text-slate-500">{dt(r.at)} – {r.user_name || "النظام"}</span></div>
              {r.before && <div className="text-xs text-slate-500">قبل: {fmt(r.before)}</div>}
              {r.after && <div className="text-xs text-slate-600">{r.before ? "بعد: " : ""}{fmt(r.after)}</div>}
              {r.reason && <div className="text-xs text-amber-700">السبب: {r.reason}</div>}
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}

export function CustomerDialog({ customer, onClose, onDone }) {
  const [f, setF] = useState({ full_name: customer.full_name || "", phone: customer.phone || "", id_number: customer.id_number || "", address: customer.address || "", notes: customer.notes || "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const save = async () => {
    setBusy(true); setErr("");
    try { await api.put(`/customers/${customer.id}`, { ...f, id_number: f.id_number || null, address: f.address || null, notes: f.notes || null }); toast.success("تم تحديث بيانات الزبون"); onDone(); onClose(); }
    catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };
  const inp = (k, label) => <Field label={label}><input className="k-input" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`customer-edit-${k}`} /></Field>;
  return (
    <Modal open onOpenChange={(o) => !o && onClose()} title="تعديل بيانات الزبون" footer={<button className="k-btn-primary" onClick={save} disabled={busy} data-testid="customer-edit-save">حفظ</button>}>
      <div className="grid gap-3">{inp("full_name", "الاسم الكامل *")}{inp("phone", "الهاتف *")}{inp("id_number", "رقم الهوية")}{inp("address", "العنوان")}{inp("notes", "ملاحظات")}<ErrorBox text={err} /></div>
    </Modal>
  );
}

export const SelectionBlock = ({ sel }) => (
  <section className="k-card p-5" data-testid="sale-selection-block"><div className="font-display font-bold text-lg mb-3">اختيار الكبش في الحضيرة</div><SelectionInfo sel={sel} /></section>
);
